import { createElement } from 'react';
import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { ndsFontReset } from '@nicollet/common';

const Heading = ({
  stackSpacing = 'x2',
  isPromotion = false,
  level = 2,
  children,
  className,
  size,
  innerHTML,
  elementRef,
  ...otherProps
}) => {
  const dangerProp = innerHTML ? {
    dangerouslySetInnerHTML: {
      __html: innerHTML
    }
  } : null;
  /* eslint-disable react/no-danger-with-children */

  return createElement(`h${level}`, {
    className,
    ref: elementRef,
    ...dangerProp,
    ...otherProps
  }, children);
};

Heading.displayName = 'Heading';
const StyledHeading = styled(Heading)`
  ${ndsFontReset()}
  color: ${({
  isPromotion
}) => isPromotion ? ndsTokens.colors.interactive.primary.default : ndsTokens.colors.text.onLight.primary};
  font-weight: ${ndsTokens.font.weight.bold};
  line-height: ${ndsTokens.font.lineHeight.heading};
  font-size: ${({
  size,
  level
}) => size || level ? // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
ndsTokens.font.size.heading[`level${size || level}`] : ndsTokens.font.size.heading.level2};
  margin: ${({
  stackSpacing
}) => {
  if (!stackSpacing) return ndsTokens.space.stack.x2;
  if (stackSpacing === '0') return '0';
  return ndsTokens.space.stack[stackSpacing];
}};
`;
StyledHeading.displayName = 'Heading';

export { StyledHeading as Heading };
